export const decodeCron = cron => {
  if (!cron) return [[], ""];
  // count length for discard second
  cron = cron.split(" ");
  const minutes = cron[2];
  const hours = cron[1];
  const dayOfWeek = cron[3].split("/")[1];
  return [
    dayOfWeek,
    `${hours < 9 ? "0" + Number(hours) : Number(hours)}:${
      minutes < 9 ? "0" + Number(minutes) : Number(minutes)
    }`
  ];
};
